import styles from "../Header.module.scss";
import Link from "next/link";
import { useRouter } from "next/compat/router";
import { useState, useEffect } from "react";
import { makeId } from "@/helpers/userHelpers";
import { MenuBuilder } from "@/components/BuilderIO/Menu/Menu.builder";
import { useSelector } from "react-redux";

export default function TopLinks({ activeLink, handleClick, handleHover,scroll,color }) {
  const router = useRouter();

  const [active, setActive] = useState(activeLink);
  const isPWA = useSelector((state) => state.pwa.is_PWA);

  useEffect(() => {
    if (router.asPath.startsWith("/impact") || router.asPath.startsWith("/charity")) {
      setActive(1);
    }
    else if (router.asPath.startsWith("/rewards")) {
      setActive(2);
    }
    else {
      setActive(0);
    }
  }, [router.asPath])

  return (
    <ul style={{color:color}}>
      {!isPWA && <li>
        <Link
            tabIndex={0}
            href="/"
            id={`shop-${makeId(3)}`}
            data-ga4={"Navigation Shop"}
            className={`normal-md large-sm x-large-xs  ${active === 0 ? styles.active : ""} shop-header auto-shop`}
            onClick={() => {
              handleClick(0);
            }}
          >
            Shop
            {scroll && active == 0 && <div className={scroll ? `${styles.menu_hide} ${styles.hide_sub_menu}` : ""}>
              {/* <MainMenu />  component for fixed header that appears on scroll, only for desktop     */}
              <MenuBuilder />
            </div>
            }
        </Link>
      </li>}
      {!isPWA && <li>
        <Link 
          tabIndex={0}
          href="/impact"
          id={`our-impact-${makeId(3)}`}
          data-ga4={"Navigation Impact"}
          className={`normal-md large-sm x-large-xs ${active === 1 ? styles.active : ""} our-impact-header auto-ourImpact`}
          onClick={() => {
            handleClick(1);
          }}>
            Our Impact
            {scroll && active == 1 && <div className={scroll ? `${styles.menu_hide} ${styles.hide_sub_menu}` : ""}>
              {/* <MainMenu />  component for fixed header that appears on scroll, only for desktop     */}
              <MenuBuilder />
            </div>
            }
        </Link>
      </li>}
    </ul>
  );
}
